import * as colors from 'components/common/colorConstants';
import styled from 'styled-components/macro';
import { lowHeightScreens, mediumScreens } from 'components/common/fontElements';

const InfoPanelSidePadding = '55px';
const cellVerticlePadding = '12px';
const hoverColor = colors.darkGray5;

// center bar styles

export const Container = styled.div`
  width: 173px;
  height: 100%;
  float: left;
  position: relative;
  z-index: 2;
  background-color: ${colors.darkGray2};
  border-right: var(--panel-border-width, 0) solid ${colors.lightGray21};
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0px;
    left: -5px;
    height: 3px;
    width: 5px;
    background: ${colors.baseBackground};
    z-index: 4;
  }

  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    width: 164px;
  }
`;

export const CenterPanelWrapper = styled.div`
  overflow: hidden;
`;

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${colors.lightGray3};
`;

export const Section = styled.div`
  width: 100%;
  padding: 6px 17px 8px;
  font-family: 'Roboto', sans-serif;
  background-color: ${(props) => props.highlight && hoverColor};
  transition: 0.3s;
  display: relative;
  word-wrap: ${(props) => props.breakWord && 'break-word'};
  &:before {
    content: '';
    display: ${(props) => props.highlight && 'block'};
    position: absolute;
    top: 0px;
    left: -2px;
    height: ${(props) => (props.length <= 1 ? '62px' : `${62 + (props.length - 1) * 24}px`)};
    width: 2px;
    background: ${hoverColor};
    border-bottom: 1px solid ${colors.lightGray3};
    @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
      height: ${(props) => (props.length <= 1 ? '62px' : `${62 + (props.length - 1) * 21}px`)};
    }
  }
  label {
    font-size: 10px;
    color: ${(props) => (props.highlight ? '#a2abba' : '#7A86A1')};
    margin-top: 0px;
    margin-bottom: 0px;
    font-weight: 500;
    @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
      font-size: 8px;
    }
  }
  p {
    color: ${(props) => (props.highlight ? colors.whiteText : '#CDD4E4')};
    font-size: 11px;
    margin-top: 0px;
    margin-bottom: 0px;
    cursor: ${(props) => props.clickable && 'pointer'};
    display: block;
    word-break: break-word;
    &:hover {
      text-decoration: ${(props) => (props.clickable ? 'underline' : 'none')};
      color: ${(props) => (props.clickable ? colors.whiteText : '#CDD4E4')};
    }
    @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
      font-size: 10px;
    }
  }
  img {
    position: absolute;
    right: 17px;
    top: 14px;
    height: 10px;
    transition: 1s;
  }
  &:hover {
    background-color: ${(props) => props.clickable && hoverColor};
    label {
      color: ${(props) => props.clickable && '#a2abba'};
    }
    &:before {
      content: '';
      display: 'block';
      position: absolute;
      top: 0px;
      left: -2px;
      height: ${(props) => (props.length <= 1 ? '62px' : `${62 + (props.length - 1) * 24}px`)};
      width: 2px;
      background: ${hoverColor};
      border-bottom: 1px solid ${colors.lightGray3};
      @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
        height: ${(props) => (props.length <= 1 ? '62px' : `${62 + (props.length - 1) * 21}px`)};
      }
    }
  }
`;

export const CustomerSection = styled(Section)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-right: 11px;
`;

export const HeaderSection = styled(Section)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.lightGray3};
  line-height: 19px;
  word-break: break-word;
  h1 {
    font-size: 11px;
    color: ${(props) => (props.highlight ? colors.whiteText : '#CDD4E4')};
    margin: 15px 14px 13px 0px;
  }
  img {
    top: 22px;
  }
  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    h1 {
      font-size: 10px;
    }
  }
`;

export const MiniSection = styled(Section)`
  label {
    font-size: 10px;
    color: ${(props) => (props.highlight ? colors.whiteText : '#7A86A1')};
    margin: 0px;
    &:hover {
      cursor: pointer;
    }
    @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
      font-size: 8px;
    }
  }
  &:before {
    content: '';
    display: ${(props) => (props.highlight ? 'block' : 'none')};
    position: absolute;
    top: 0px;
    left: -2px;
    height: 39px;
    width: 2px;
    background: ${hoverColor};
    border-top: 1px solid ${colors.lightGray3};
    border-bottom: 1px solid ${colors.lightGray3};
    @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
      height: 35px;
    }
  }
  &:hover {
    cursor: pointer;
    background-color: ${hoverColor};
    label {
      color: ${colors.whiteText};
    }
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0px;
      left: -2px;
      height: 39px;
      width: 2px;
      background: ${hoverColor};
      border-top: 1px solid ${colors.lightGray3};
      border-bottom: 1px solid ${colors.lightGray3};
      @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
        height: 35px;
      }
    }
  }
`;

// popup info panel styles

export const InfoPanel = styled.div`
  display: ${(props) => (props.active ? 'block' : 'none')};
  position: absolute;
  top: 0px;
  right: -446px;
  width: 446px;
  height: 100%;
  background: ${colors.baseBackground};
  animation-name: scrollOut;
  animation-duration: 1s;
  overflow-y: ${(props) => !props.disableScroll && 'scroll'};
  h1 {
    font-size: 20px;
    margin: 0px;
  }

  @keyframes scrollOut {
    0% {
      width: 0px;
      right: 0px;
    }
    100% {
      width: 446px;
      right: -446px;
    }
  }
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    h1 {
      font-size: 16px;
    }
  }
`;

export const InfoPanelContent = styled.div`
  animation-name: fadeIn;
  animation-duration: 0.3s;
  animation-delay: 1s;
  animation-fill-mode: forwards;
  opacity: 0%;
  height: 100%;
  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const InfoPanelNavigation = styled.div`
  color: ${colors.slateGray};
  border-bottom: 1px solid ${colors.lightGray15};
  padding: 20px ${InfoPanelSidePadding} 0px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  font-size: 12px;
  img {
    position: absolute;
    top: 20px;
    right: 15px;
    cursor: pointer;
  }
`;

export const CommerceWizardNavigation = styled(InfoPanelNavigation)`
  height: 55px;
  padding: 20px ${InfoPanelSidePadding} 24px 24px;
  align-items: center;

  h2 {
    display: ${(props) => (props.shouldDisplayText ? 'inline-block' : 'none')};
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 10px;
    margin: 0px;
    padding: 0px;
    color: ${colors.lightBlack};
  }
`;

export const NavigationTab = styled.div`
  color: ${(props) => (props.selected ? colors.blue1 : colors.slateGray)};
  border-bottom: ${(props) => (props.selected ? `2px solid ${colors.blue1}` : 'none')};
  height: 35px;
  display: flex;
  align-items: flex-start;
  margin: 0px ${InfoPanelSidePadding} 0px 0px;
  transition: color 0.5s linear;
  cursor: pointer;
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    font-size: 10px;
  }
`;

export const InfoPanelHeader = styled.div`
  color: ${colors.black};
  padding: ${(props) =>
    props.bottomPadding ? `33px ${InfoPanelSidePadding} ${props.bottomPadding}` : `33px ${InfoPanelSidePadding} 20px`};
  h1 {
    @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
      font-size: 16px;
    }
  }
  p {
    color: ${colors.slateGray};
    font-family: Arial;
    font-size: 14px;
    line-height: 20px;
    margin-top: 25px;
    @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
      font-size: 10px;
      margin-top: 15px;
    }
  }
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    padding: ${(props) => (props.listMode ? `33px ${InfoPanelSidePadding} 15px` : `33px ${InfoPanelSidePadding} 20px`)};
  }
`;

export const InfoPanelSubheader = styled(InfoPanelHeader)`
  padding: 30px ${InfoPanelSidePadding} 20px;
  h2 {
    font-weight: 500;
    font-size: 16px;
    margin: 0px;
  }
`;

// styles for order section

export const InfoPanelRow = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.lightGray15};
  padding: ${cellVerticlePadding} ${InfoPanelSidePadding};
  display: flex;
  justify-content: space-between;
  font-family: Roboto, sans-serif;
  font-size: 13px;
  background-color: ${(props) => props.menuActive && colors.lightGray23};
  transition: 0.3s;
  cursor: ${(props) => props.clickable && 'pointer'};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    font-size: 10px;
  }
  label {
    color: ${(props) => (props.menuActive ? colors.blue1 : colors.lightBlack)};
    font-weight: normal;
    margin: 0px 40px 0px 0px;
  }
  p {
    display: inline-block;
    font-weight: ${(props) => (props.clickable ? '500' : 'bold')};
    color: ${
      // eslint-disable-next-line
      (props) => (props.menuActive ? colors.blue1 : props.clickable ? colors.darkGray14 : colors.lightBlack)
    };
    margin: 0px;
    text-align: right;
    cursor: ${(props) => props.clickable && 'pointer'};
  }
  img {
    margin-left: 3px;
  }
`;

export const ItemRow = styled(InfoPanelRow)`
  padding: ${cellVerticlePadding} ${InfoPanelSidePadding} ${cellVerticlePadding} 80px;
  background-color: ${colors.darkWhite1};
  a {
    color: ${colors.lightBlack};
    text-decoration: underline;
    &:hover {
      color: ${colors.lightBlack};
    }
  }
`;

export const ItemInfoWrapper = styled.div`
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
  opacity: 0%;
  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const CenterPanelFadeBackground = styled.div`
  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 0.8;
    }
  }

  width: 100%;
  height: 100%;
  background-color: ${colors.lightBlack};
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.8;
  transition: 0.6s;
  animation-name: fadein;
  animation-duration: 0.5s;
`;

export const Table = styled.table`
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  table-layout: fixed;
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    font-size: 10px;
  }
`;

export const TableHeaderSection = styled.thead``;
export const TableBodySection = styled.tbody``;

export const Row = styled.tr`
  cursor: ${(props) => props.hoverPointer && 'pointer'};
  border-bottom: 1px solid ${colors.lightGray12};
  background-color: ${(props) => (props.even ? colors.baseBackground : colors.darkWhite1)};
  transition: 0.3s;
  &:hover {
    background-color: ${colors.lightGray30};
  }
`;

export const HeaderRow = styled.tr`
  border-bottom: 1px solid ${colors.lightGray12};
  background-color: ${(props) => (props.even ? colors.baseBackground : colors.darkWhite1)};
  transition: 0.3s;
`;

export const TableData = styled.td`
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: ${(props) => (props.dark ? colors.lightBlack : colors.slateGray)};
  text-align: ${(props) => (props.center ? 'right' : 'left')};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: ${(props) =>
    props.center
      ? `${cellVerticlePadding} ${InfoPanelSidePadding} ${cellVerticlePadding} 5px`
      : `${cellVerticlePadding} 5px ${cellVerticlePadding} ${InfoPanelSidePadding}`};
  &:hover {
    cursor: ${(props) => props.dark && 'pointer'};
    text-decoration: ${(props) => props.dark && 'underline'};
  }
`;

export const TableHeader = styled.th`
  background-color: ${colors.darkWhite1};
  font-stretch: condensed;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${colors.darkGray14};
  font-size: 10px;
  padding: ${(props) =>
    props.center
      ? `${cellVerticlePadding} ${InfoPanelSidePadding} ${cellVerticlePadding} 5px`
      : `${cellVerticlePadding} 5px ${cellVerticlePadding} ${InfoPanelSidePadding}`};
  text-align: ${(props) => (props.center ? 'center' : 'left')};
`;

export const CommerceIcon = styled.div`
  background-color: ${colors.blue1};
  color: ${colors.whiteText};
  border-radius: 5px;
  width: 50px;
  height: 24px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  cursor: pointer;

  img {
    position: relative;
    top: 0px;
    left: 0px;
    right: 0px;
  }
`;
